import { render } from "./web-footer.vue?vue&type=template&id=143cdd9f&scoped=true"
const script = {}

import "./web-footer.vue?vue&type=style&index=0&id=143cdd9f&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/qd-chilecashy-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143cdd9f"]])

export default __exports__